import { render, staticRenderFns } from "./ReservaExpressaPage.vue?vue&type=template&id=31873571"
import script from "./ReservaExpressaPage.vue?vue&type=script&lang=js"
export * from "./ReservaExpressaPage.vue?vue&type=script&lang=js"
import style0 from "./ReservaExpressaPage.vue?vue&type=style&index=0&id=31873571&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports